import { render, staticRenderFns } from "./DocumentsDesktop.vue?vue&type=template&id=55873d24&scoped=true&"
import script from "./DocumentsDesktop.vue?vue&type=script&lang=js&"
export * from "./DocumentsDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55873d24",
  null
  
)

export default component.exports